<template>
    <div class="page-content view-bookSearch">
        <div class="bookingSearchWrapper">
            <div class="bookSearch-container">
                <p class="bookSearch-title">填写订单查询所需信息</p>
                <p class="bookSearch-txt">可查看订单详情并进行在线支付</p>
                <p class="bookSearch-txt">可将电话订单转为线上订单，在线查看详情并支付</p>
                <div class="cruise-switch-container">
                    <div class="cruise-hp cruise-switch-wrapper active">
                        <div class="cruise-switch">
                            <img src="https://resource.rcclchina.com.cn/tui2/user_center/item-selected.png">
                        </div>
                        <div class="cruise-switch-text">中国出发航线</div>
                    </div>
                    <div class="cruise-row cruise-switch-wrapper">
                        <div class="cruise-switch row-switch">

                        </div>
                        <div class="cruise-switch-text">海外出发航线</div>
                        <a :href="rowSearchLink" class="external"></a>
                    </div>
                </div>
                <div class="bookSearch-input">
                    <div class="row-input">
                        <span>订单号：</span>
                        <input v-model="bookingId" type="text" class="orderNo" placeholder="不足7位请补0，例: 0012345">
                    </div>
                    <div class="row-input">
                        <span>姓(拼音)：</span>
                        <input v-model="lastName" type="text" class="PinYinName" placeholder="例如：LI">
                    </div>
                    <div class="row-input">
                        <span>所乘游轮：</span>
                        <div class="selectShips select-item">
                            <select v-model="shipCode">
                                <option value="WN">海洋奇迹号</option>
                                <option value="SC">海洋光谱号</option>
                                <option value="OV">海洋赞礼号</option>
                                <option value="QN">海洋量子号</option>
                                <option value="VY">海洋航行者号</option>
                            </select>
                        </div>
                        <div class="select-arrowIcon"><i class="f7-icons">down</i></div>
                    </div>
                    <div class="row-input">
                        <span>出航日期：</span>
                        <input type="date" v-model="sailDate" class="sailDate" placeholder="请选择出航日期">
                        <div class="calendarIcon">
                            <img src="https://resource.rcclchina.com.cn/bookingPay/calendarIcon.png">
                        </div>
                    </div>
                </div>
                <div class="bookSearch-button" @click="submitBookingSearch()">立即查询</div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
export default {
    name: "BookingSearch",
    data () {
        return {
            lastName: '',
            shipCode: 'WN',
            sailDate: moment().format('yyyy-MM-DD'),
            bookingId: ''
        }
    },
    mounted () {
        this.$store.commit('SET_PAGE_TITLE', '订单查询')
        const userToken = this.$store.state.user.userToken
        if (!userToken || userToken.length == 0) {
            this.$confirm.show('请登录后，再进行订单查询', {
                confirmCallBack: ()=> {
                    this.goToLogin()
                }
            })
        }
    },
    methods: {
        async submitBookingSearch () {
            if (this.lastName.trim() == '') {
                this.$alert.show('请输入姓(拼音)')
                return
            } else if (!this.pyNameCheck(this.lastName)) {
                this.$alert.show('请输入正确的姓(拼音)')
                return
            }
            if (this.bookingId.trim() == '') {
                this.$alert.show('请输入订单号')
                return
            }
            if (this.sailDate.trim() == '') {
                this.$alert.show('请选择出航日期')
                return
            }
            const requestData = {
                bookingId: this.bookingId,
                lastName: this.lastName,
                sailDate: this.sailDate,
                shipCode: this.shipCode,
                agencyId: '333545'
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.bookingSearch(requestData)
            this.$loading.hide()
            if (!success) {
                if (errMsg == 'USER_LOGIN_ERROR') {
                    return this.goToLogin()
                }
                this.$alert.show(errMsg)
                return
            }
            this.$router.push({ name: 'BookingDetail', query:{
                bookingId: this.bookingId
            }})
        },
        goToLogin () {
            this.$router.push({ name: 'Login', query:{
                returnUrl: location.href
            }})
        },
        pyNameCheck(pyName) {
            //中文验证
            if (!/^[A-Za-z]+$/.test(pyName)) {
                return false;
            }
            return true;
        }
    },
    computed: {
        rowSearchLink () {
            return '/Rccl.Campaign/RedirectToTui?redirectUrl='+process.env.VUE_APP_TUI_URL + +'/Booking/MobileBookingSearch'
        }
    }
}
</script>

<style lang="less" scoped>
.view-bookSearch .bookingSearchWrapper {
    padding-bottom: 7rem;
    background-image: url("https://resource.rcclchina.com.cn/bookingPay/bookSearchBg.jpg");
    background-repeat: no-repeat;
    background-size: 100%;
    background-color: #2f71b0;
}
.view-bookSearch nav.home-bar-nav {
    background-color:#061556;
}
.view-bookSearch .bookSearch-container {
   margin-left:12px;
   margin-right:12px;
}
.view-bookSearch .bookSearch-title {
    font-size:13px;
    color:#f9b811;
    padding-top: 166px;
    margin-top: 0px;
    margin-bottom:20px;
    text-align:center;
}
.view-bookSearch .bookSearch-txt{
    font-size:11px;
    color:#fff;
    margin:0;
    text-align:center;
}
.view-bookSearch .bookSearch-input {

    overflow:hidden;
}
.view-bookSearch .row-input {
    background-color:#fff;
    margin-bottom:16px;
    padding-left:18px;
    padding-right:11px;
    height:36px;
    line-height:36px;
    position:relative;
}
.view-bookSearch .row-input span{
    font-size:13px;
    color:#061556;
    display:inline-block;
    width:66px;
    text-align:left;
}
.view-bookSearch .row-input input{
    font-size:13px;
    color:#4d4d4d;
    margin-left:45px;
    text-align:center;
    width:200px;
    height:33px;
    line-height:35px;
    border:none;
    text-indent:4px;
}
.view-bookSearch .row-input input::-webkit-input-placeholder{
    font-size:13px;
    color:#aeaeae;
}
.view-bookSearch .row-input .select-item {
    position:absolute;
    top:0;
    right:0;
    z-index:3;
}
.view-bookSearch .row-input .select-item select{
    border:1px solid #aeaeae;
    font-size:13px;
    color:#000;
    padding:2px 0 2px 50px;
    width:200px;
    height:34px;
    line-height:34px;
    text-align:center;
    border:none;
    appearance:none;
    -moz-appearance:none;
    -webkit-appearance:none;
    background-color:transparent;
}
select::-ms-expand { display: none; }
.view-bookSearch .row-input .select-arrowIcon {
    position:absolute;
    right:12px;
    top:2px;
    z-index:1;
}
.view-bookSearch .row-input .select-arrowIcon .f7-icons{
    font-size:16px;
    color:#061556;
}
.view-bookSearch .row-input .sailDate {
    position:absolute;
    top:0;
    right:11px;
    padding-right:12px;
    background-color:transparent;
    z-index:3;
}
.view-bookSearch .row-input .calendarIcon {
    width:21px;
    height:21px;
    position:absolute;
    right:11px;
    top:7px;
    z-index:2;
}
.view-bookSearch .row-input .calendarIcon img{
    width:100%;
}
.view-bookSearch .bookSearch-button {
    margin-top:5px;
    height:36px;
    line-height:36px;
    text-align:center;
    color:#061556;
    font-size:13px;
    background-color:#f9b811;
}


.cruise-switch-container {
    font-size: 17px;
    color: white;
    text-align: center;
    margin: 14px 0px;
}

.cruise-switch-wrapper {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
    margin-left: 5px;
}

.cruise-switch-wrapper>div {
    display: inline-block;
    vertical-align: middle;
}

.cruise-switch-wrapper .cruise-switch {
    width: 17px;
    height: 17px;;
}

.cruise-switch-wrapper .cruise-switch img {
    width: 100%;
}

.cruise-switch-wrapper .row-switch {
    border: 1px solid #f9b811;
    border-radius: 8.5px;
}

.cruise-row {
    margin-left: 20px;
}

.cruise-row a {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}
</style>
